export default "__VITE_ASSET__BQc9wv6u__"